import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--menu-item-form"
export default class extends Controller {
  static targets = ["pageField", "urlField", "linkSettingsField"]
  static values = {
    linkType: String
  }

  connect() {
    this.linkTypeValue = this.linkTypeValue || "page"
    this.toggleFields()
  }

  changeType(event) {
    this.linkTypeValue = event.target.value
    this.toggleFields()
  }

  toggleFields() {
    const type = this.linkTypeValue
    this.toggleField(this.pageFieldTarget, this.isPageType(type))
    this.toggleField(this.urlFieldTarget, this.isExternalType(type))
    this.toggleField(this.linkSettingsFieldTarget, !this.isTitleType(type))
  }

  toggleField(target, shouldShow) {
    if (!target) return

    target.classList.toggle("hidden", !shouldShow)

    target.querySelectorAll("input, select, textarea").forEach((element) => {
      element.disabled = !shouldShow
    })
  }

  isPageType(type) {
    return type === "page"
  }

  isExternalType(type) {
    return ["external", "external_url"].includes(type)
  }

  isTitleType(type) {
    return ["mega_menu_root", "heading", "dropdown_heading", "title"].includes(type)
  }
}
